module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-easel-fill-a1ae2114.svg";